<div class="page-header">
  <material-navbar
    menuPosition="dashboard"
    [container]="true"
  ></material-navbar>

  <div class="header-body container text-black">
    <div class="row w-100" *ngIf="!currentUser.isAdmin()">
      <mat-card class="mat-elevation-z0 col-lg-12">
        <mat-card-content>
          <div class="row">
            <div class="col-lg-10">
              <mat-card-title>My Sites</mat-card-title>
              <mat-card-subtitle
                >Select a site to edit,view and open its
                dashboard</mat-card-subtitle
              >
            </div>
            <div class="col-lg-2">
              <div class="actions btn-action">
                <ng-container *ngIf="settings.get('billing.enable')">
                  <a
                    class="upgrade-button"
                    mat-raised-button
                    color="accent"
                    routerLink="/billing/subscription"
                    *ngIf="currentUser.isSubscribed()"
                  >
                    <mat-icon svgIcon="flash-on"></mat-icon>
                    <span trans>Manage Subscription</span>
                  </a>
                  <a
                    class="upgrade-button"
                    mat-raised-button
                    color="accent"
                    routerLink="/billing/upgrade"
                    *ngIf="!currentUser.isSubscribed()"
                  >
                    <mat-icon svgIcon="flash-on"></mat-icon>
                    <span trans>Upgrade to Premium</span>
                  </a>
                </ng-container>
                <a
                  class="new-project-button mt-3"
                  mat-raised-button
                  color="warn"
                  routerLink="/dashboard/projects/new"
                  trans
                  *ngIf="shouldShowNewProjectButton"
                >
                  <div class="row px-3 button-adj">
                    <mat-icon svgIcon="add"></mat-icon>
                    <span>Create New Site</span>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>

    <div class="row justify-contnet-end w-100 remove-left" *ngIf="currentUser.isAdmin()">
      <div class="col-lg-6 pad-rgt"></div>
      <div class="col-lg-6 pad-rgt">
        <div class="row justify-contnet-end remove-left">
          <a
            class="new-project-button mt-3"
            mat-raised-button
            color="warn"
            routerLink="/dashboard/projects/new"
            trans
          >
            <div class="row px-3 button-adj">
              <mat-icon svgIcon="add"></mat-icon>
              <span>Create New Site</span>
            </div>
          </a>
          <form
            class="inputs col-lg-8 mt-2"
            [formGroup]="models"
            
          >
            <div class="input-container">
              <div class="input-container search-input-container">
                <mat-icon
                  class="search-icon text-clr"
                  svgIcon="search"
                ></mat-icon>
                <input
                  type="text"
                  class="search-input"
                  formControlName="query"
                  placeholder="Search for a site..."
                />
              </div>
            </div>

            <!-- <div class="input-container">
              <label for="project-status" class="font-14" trans>Status</label>
              <select formControlName="published" id="project-status">
                <option value="all" trans>All</option>
                <option [ngValue]="1" trans>Published</option>
                <option [ngValue]="0" trans>Unpublished</option>
              </select>
            </div>
      
            <div class="input-container">
              <label for="project-order" class="font-14" trans>Sort</label>
              <select formControlName="order" id="project-order">
                <option value="created_at|desc" trans>Newest</option>
                <option value="created_at|asc" trans>Oldest</option>
                <option value="name|desc" trans>A-Z</option>
                <option value="name|asc" trans>Z-A</option>
              </select>
            </div> -->
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<section class="be-container">
  <ad-host slot="ads.dashboard_top" class="ad-host-top"></ad-host>

  <mat-tab-group color="accent" animationDuration="0">
    <mat-tab [label]="'Projects' | trans">
      <div class="tab-content projects">
        <div class="auto-height-grid template-grid">
          <ng-container *ngFor="let project of projects$ | async; index as i">
            <div class="grid-wrapper" iframeControl>
              <div class="grid-item">
                <div class="grid-content">
                  <iframe
                    scrolling="no"
                    sandbox="allow-same-origin allow-scripts allow-popups allow-top-navigation allow-forms"
                    [ngClass]="getIframeClass(project)"
                    #iframeSection
                    (load)="checkModalPopup(iframeSection)"
                    frameborder="0"
                    allowfullscreen
                    [src]="getProjectUrl(project) | safe"
                    width="100%"
                    crossorigin="allow-origin"
                    height="100%"
                  ></iframe>
                  <!--img
                    [src]="getProjectImage(project)"
                    (click)="openBuilder(project)"
                    alt="{{ project.name }} image"
                  /-->
                </div>
              </div>
              <div style="display: none" class="hoverSection">
                <div class="row justify-content-center cSection"></div>
                <button
                  class="btn btn-info btn-block c-button btn-lg"
                  (click)="openBuilder(project)"
                  trans
                >
                  Edit
                </button>
              </div>

              <div class="grid-label">
                <div class="title">
                  <div class="name" (click)="openBuilder(project)">
                    Project Name : {{ project.name }}
                  </div>
                  <div
                    class="name"
                    (click)="openBuilder(project)"
                    *ngIf="project.domain_name"
                  >
                    Domain Name :
                    <a
                      style="color: #444444"
                      *ngIf="project.domain_name"
                      href="https://{{ project.domain_name }}"
                      target="_blank"
                      >{{ project.domain_name }}</a
                    >
                  </div>
                  <div class="name">
                    Status :
                    <span class="text-{{ getStatusColor(project) }}">{{
                      getStatus(project)
                    }}</span>
                  </div>
                  <div class="name" *ngIf="project.ssl_exipre_date">
                    SSL Expired Date :
                    <span
                      >{{ formatDateString(project.ssl_exipre_date) }}
                    </span>
                  </div>
                </div>
                <div class="actions">
                  <button
                    type="button"
                    [matMenuTriggerFor]="menu"
                    mat-icon-button
                  >
                    <mat-icon svgIcon="more-vert"></mat-icon>
                  </button>
                  <mat-menu #menu="matMenu">
                    <button mat-menu-item (click)="openBuilder(project)" trans>
                      Edit
                    </button>
                    <a
                      [href]="getProjectUrl(project)"
                      target="_blank"
                      mat-menu-item
                      trans
                      >Preview</a
                    >
                    <!-- <button mat-menu-item (click)="openDnsModal(project)" trans>
                      Dns
                    </button> -->
                    <button
                      mat-menu-item
                      (click)="openProjectSettingsModal(project)"
                      trans
                    >
                      DNS Settings
                    </button>
                    <button mat-menu-item (click)="onUnpublish(project)" trans>
                      Unpublish
                    </button>
                    <button
                      mat-menu-item
                      (click)="deleteProjectWithConfirmation(project)"
                      trans
                      class="mat-warn"
                    >
                      Delete
                    </button>
                  </mat-menu>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>

      <no-results-message
        *ngIf="!(projects$ | async).length"
        svgImage="website-builder.svg"
      >
        <span primary-text *ngIf="models.controls.query.value" trans
          >Not matching projects found.</span
        >
        <span primary-text *ngIf="!models.controls.query.value" trans
          >You have not created any projects yet.</span
        >
      </no-results-message>
    </mat-tab>

    <!-- <mat-tab
      [label]="'Domains' | trans"
      *ngIf="
        settings.get('builder.enable_custom_domains') &&
        currentUser.hasPermission('custom_domains.create')
      "
    >
      <div class="domains-tab tab-content">
        <button
          type="button"
          mat-raised-button
          color="accent"
          (click)="userDomains.openConnectDomainModal().subscribe()"
          trans
        >
          Connect Domain
        </button>

        <ul class="domains unstyled-list">
          <li
            class="domain"
            *ngFor="let domain of userDomains.domains$ | async"
          >
            <div class="domain-content">
              <div class="host">{{ domain.host }}</div>
              <div class="date">{{ domain.created_at | formattedDate }}</div>
              <div *ngIf="domain.resource" class="domain-project">
                <img [src]="getProjectImage(domain.resource)" alt="" />
                <div class="name">{{ domain.resource.name }}</div>
              </div>
              <div *ngIf="!domain.resource" class="domain-project" trans>
                This domain is not attached to any project.
              </div>
            </div>
            <div class="domain-actions">
              <button type="button" [matMenuTriggerFor]="menu" mat-icon-button>
                <mat-icon svgIcon="more-vert"></mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <button mat-menu-item [matMenuTriggerFor]="projects" trans>
                  Change Project
                </button>
                <button
                  mat-menu-item
                  (click)="userDomains.maybeRemoveDomain(domain)"
                  trans
                >
                  Remove
                </button>
              </mat-menu>
              <mat-menu #projects="matMenu">
                <div
                  mat-menu-item
                  *ngFor="let project of projects$ | async"
                  class="project-menu-item"
                  (click)="
                    userDomains
                      .attachDomainToProject(project, domain)
                      .subscribe()
                  "
                >
                  <img [src]="getProjectImage(project)" alt="" />
                  <div class="project-name">{{ project.name }}</div>
                </div>
              </mat-menu>
            </div>
          </li>
        </ul>

        <no-results-message
          *ngIf="!(userDomains.domains$ | async).length"
          svgImage="custom-domain.svg"
        >
          <span primary-text trans>You have not attached any domains yet.</span>
        </no-results-message>
      </div>
    </mat-tab> -->
  </mat-tab-group>

  <ad-host slot="ads.dashboard_bottom" class="ad-host-bottom"></ad-host>
</section>

<loading-indicator
  [isVisible]="loading$ | async"
  class="overlay"
></loading-indicator>
